import { createAtom } from '@xstate/store';

import type { AudioPlayerStreamingAction } from '../effects/AudioPlayerStreamingManager';

export enum AudioStreamingState {
	UNINITIALIZED = 'uninitialized',
	LOADING = 'loading',
	ERROR = 'error',
	STREAM_STARTED = 'stream_started',
	STREAM_DISPOSED = 'stream_disposed',
}

type AudioPlayerStreamingResult =
	| {
			state: AudioStreamingState.UNINITIALIZED;
	  }
	| {
			state: AudioStreamingState.LOADING;
	  }
	| {
			state: AudioStreamingState.ERROR;
			error: Error;
	  }
	| {
			state: AudioStreamingState.STREAM_STARTED;
			response: ReadableStream;
	  }
	| {
			state: AudioStreamingState.STREAM_DISPOSED;
	  };

export const audioPlayerStreamingStore = createAtom<AudioPlayerStreamingResult>({
	state: AudioStreamingState.UNINITIALIZED,
});

export const setAudioPlayerStreamingStore = (action: AudioPlayerStreamingAction) => {
	switch (action.type) {
		case AudioStreamingState.UNINITIALIZED:
			audioPlayerStreamingStore.set({ state: AudioStreamingState.UNINITIALIZED });
			break;
		case AudioStreamingState.LOADING:
			audioPlayerStreamingStore.set({ state: AudioStreamingState.LOADING });
			break;
		case AudioStreamingState.ERROR:
			audioPlayerStreamingStore.set({ state: AudioStreamingState.ERROR, error: action.error });
			break;
		case AudioStreamingState.STREAM_STARTED:
			audioPlayerStreamingStore.set({
				state: AudioStreamingState.STREAM_STARTED,
				response: action.response,
			});
			break;
		case AudioStreamingState.STREAM_DISPOSED:
			audioPlayerStreamingStore.set({ state: AudioStreamingState.STREAM_DISPOSED });
			break;
	}
};
